import { registerDocumentReference } from "../slices/documentReferenceSlice";
import { logErrorEvent } from "../services/logService";

/**
 * Fetch a DocumentReference by ID
 * - Checks Redux store first
 * - Fetches from FHIR server if missing
 * - Registers into Redux
 */
export const fetchDocumentReference = async (docRefId, fhirClient, store, { forceFetch = false } = {}) => {
    console.log("fetching DocumentReference by id");
    console.log(docRefId);
    console.log(fhirClient);
    

    if (!docRefId || !fhirClient) return null;

    // Check Redux cache
    const cached = store.getState().documentReferences?.[docRefId];
    if (cached && !forceFetch) {
        console.log(`🧠 DocumentReference ${docRefId} served from cache`);
        return cached;
    }

    try {
        console.log(`🌐 Fetching DocumentReference/${docRefId} from FHIR`);
        const fetched = await fhirClient.request(`DocumentReference/${docRefId}`);

        if (fetched?.resourceType !== "DocumentReference") {
            console.warn("⚠️ Unexpected DocumentReference response:", fetched);
            return null;
        }

        console.log("dispatching...");
        store.dispatch(registerDocumentReference(fetched));
        return fetched;

    } catch (err) {
        console.error("❌ Failed to fetch DocumentReference:", err);
        const status = err?.response?.status || err?.status || 500;
        logErrorEvent({
            errorType: "read",
            error: {
                message: err?.message || "DocumentReference fetch failed",
                status,
                resourceId: `DocumentReference/${docRefId}`
            },
            description: `Failed to retrieve DocumentReference/${docRefId} from FHIR server`,
            store
        });
        return { error: status };
    }
};


/**
 * Fetch a DocumentReference given a FHIR reference string
 * e.g. "DocumentReference/123" or "DocumentReference/123/_history/4"
 */
export const fetchDocumentReferenceByReference = async (ref, fhirClient, store, options = {}) => {
    console.log("fetching DocumentReference by Reference....................");

    if (!ref || typeof ref !== "string") {
        console.warn("⚠️ Invalid DocumentReference reference (not a string):", ref);
        return null;
    }

    if (!ref.startsWith("DocumentReference/")) {
        console.warn("⚠️ Reference is not a DocumentReference:", ref);
        return null;
    }

    // Extract ID safely (handles versioned refs)
    const parts = ref.split("/");
    const docRefId = parts[1];

    if (!docRefId || docRefId === "undefined" || docRefId === "null") {
        console.warn("⚠️ Could not extract valid DocumentReference ID from reference:", ref);
        return null;
    }

    return fetchDocumentReference(docRefId, fhirClient, store, options);
};
